import apiClient from '../client';
import {
  BASE_ENDPOINTS,
  RESOURCES,
  SERVICES,
  VERSIONS
} from '../common/constants';

const SMS_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.DIGITIZATION,
  VERSIONS.V1,
  RESOURCES.SMS,
  false
);

export const getGroupTemplateData = async ({
  tenant,
  cursor,
  limit,
  filter
}) => {
  const url = `${SMS_BASE}/category/report`;
  const data = await apiClient.post(url, {
    cursor: cursor,
    limit: limit,
    search_text: filter
  });
  // console.log(data, 'data from dynamic api');
  return data;
};

export const getGroupTemplate = async ({ tenant }) => {
  const url = `${SMS_BASE}/category/form`;
  const data = await apiClient.get(url);
  return data;
};

export const createGroupTemplate = async ({ tenant, combinedData }) => {
  const data = await apiClient.post(`${SMS_BASE}/category/`, combinedData);
  return data;
};

export const editSubmitGroupTemplate = async ({ tenant, id, combinedData }) => {
  const data = await apiClient.put(`${SMS_BASE}/category/${id}`, combinedData);
  return data;
};

export const deleteGroupTemplate = async ({ tenant, id }) => {
  const data = await apiClient.delete(`${SMS_BASE}/category/${id}`);
  return data;
};

export const editGroupTemplate = async ({ tenant, id }) => {
  const data = await apiClient.get(`${SMS_BASE}/category/${id}`);
  return data;
};
